module.exports = __webpack_public_path__ + "static/media/1 16 vert.39f71b61.mp3";